module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-double-right-c38ee2a2.svg";